<template>
  <vue-scroll :ops="ops" ref="vs" @handle-scroll="handleScroll">
    <div class="pro">
      <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=3 ></first-Component>

      <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=3 v-if="!isShowNav"></first-Component>
      <div class="banner animated zoomIn" id="d1">
            <div class="text">
              <span>{{$t('home[0]')}}</span>
            </div>
            <img  style="width:100%;height:100%;cursor: pointer;display: block" ref="bannerHeight"  src="../assets/proBanner.jpg">
            <div class="threeBtn">
              <ul>
                <li v-for="(item,index) in navList" :style="select2===index?oneStyle:''" @click="showCon(index,item.ID)" @mouseenter="getTwo(item.ID)" @mouseleave="remove">
                  <span>{{item.CALLED}}</span>
                  <div class="proItem animated fadeInUp"  :style="firstList.length==0?ycStyle:''" >
                   <p v-for="(i,ind) in firstList" :key="ind" @click.stop="showCon2(ind,i.ID)">- {{i.CALLED}}</p>
                  </div>
                </li>
              </ul>
            </div>
      </div>
      <div class="title wow fadeInUp">
        <p>{{MainTitle}}</p>
        <div class="three">
          <span style="left: 0"></span>
          <img src="../assets/d.png" alt="">
          <span style="right: 0;"></span>
        </div>
      </div>
      <div class="main wow fadeInUp ">
        <div class="fourImg" >
          <div class="item" v-for="(item,index) in imgList" :key="index" @click="gotoInfo(item.ID)">
            <img :src="`http://www.nbbinyu.com/upload/${item.SMALLPIC}`" alt="">
            <div class="twoText">
              <span>{{item.PRONAME}}</span>
              <span>{{item.TITLE2}}</span>
            </div>
            <div class="fourLine">
              <div class="anim-border">
                <s class="oneLine loc_l"></s>
                <s class="oneLine loc_r"></s>
                <s class="oneLine loc_t"></s>
                <s class="oneLine loc_b"></s>
              </div>
            </div>
          </div>
        </div>
        <div class="an wow fadeInUp">
          <span class="btn" @click="getMorePro">{{$t('btn')}}</span>
        </div>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
  </vue-scroll>
</template>

<script>
  import firstComponent from './first'
  import footComponent from './foot'
  import  {WOW} from 'wowjs'
  import {getProductstypeUrl2,getProductsUrl} from '../util/lang'
    export default {
        name: "product",
      data(){
          return{
            // item:'',
            totalPage:'',
            page:2,
            ID:'25',
            ycStyle:{display:'none'},
            firstList:[],
            navList:[
              {CALLED:''}
            ],
            aStyle:{display:'inline-block !important'},
            isShowNav:true,
            imgList:[],
            oneStyle:{
              backgroundColor:' #0C3665',
              color:'white'
            },
            select2:0,
            ops: {
              vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true
              },
              scrollPanel: {
                speed: 300,
                scrollingX: false,
              },
              rail: {
                background: '#01a99a',
                opacity: 0,
                size:'2px'
              },
              bar: {
                showDelay: 500,
                background: '#0C3665',
                size: '2px',
              }
            },
          }
      },
      computed:{
    MainTitle:function () {
     return this.navList[this.select2].CALLED
    }
      },
      mounted(){
        if(this.$route.query.select!=undefined || this.$route.query.id!=undefined){
          this.select2=this.$route.query.select
          let id =this.$route.query.id
          this.getProduct(id)
        }else{
          console.log("路由跳转参数为空")
          if(this.$i18n.locale==='en'){
            this.getProduct('25')
          }else{
            this.getProduct('87')
          }
        }
        this.wow=new WOW();
        this.wow.init()
        this.getPro()
        console.log(this.$i18n.locale)
      },
      components:{firstComponent,footComponent},
      methods:{
        gotoTop(){
          this.$refs['vs'].scrollIntoView('#d1', 500);
        },
        getMorePro(){
          if(this.page<=this.totalPage){
            this.$nextTick(()=>{
              const url = `${getProductsUrl( this.$i18n.locale,this.ID,12,this.page++)}`
              this.$axios.get(url).then(res => {
                this.imgList=this.imgList.concat(res.data.proarr)
              })
            })
          }else{
            this.$notify({
              title: '提示',
              message: '已经加载全部拉',
              offset: 100
            });
          }
        },
        getProduct(id){
          this.page=2
          this.$nextTick(()=>{
            const url = `${getProductsUrl( this.$i18n.locale,id,12,1)}`
            this.$axios.get(url).then(res => {
              this.imgList=res.data.proarr
              // console.log(res.data)
              this.totalPage=res.data.pagershow.totalPagers
              // this.item= parseInt(res.data.pagershow.items)-12
            })
          })
        },
        remove(){
          this.firstList=[]
        },
        getTwo(id){
       if(document.body.clientWidth>=768)
       {
         this.$nextTick(()=>{
           const url = `${getProductstypeUrl2( this.$i18n.locale,id)}`
           this.$axios.get(url).then(res => {
             this.firstList=res.data
           })
         })
       }else{
         this.firstList=[]
       }
        },
        getPro(){
          this.$nextTick(()=>{
            const url = `${getProductstypeUrl2( this.$i18n.locale)}`
            this.$axios.get(url).then(res => {
              this.navList=res.data.slice(1,6)
            })
          })
        },
        handleScroll(vertical, horizontal, nativeEvent) {
          let top=vertical.scrollTop
          if(top>0){
            this.isShowNav=false
          }else{
            this.isShowNav=true
          }
          window.pageYOffset=top
          this.wow.scrollHandler()
        },
        gotoInfo(id){
          this.$router.push({path:'/productInfo',query:{id:id}})
        },
        showCon2(n,id){
          this.ID=id
          this.getProduct(id)
        },
        showCon(n,id){
          this.select2=n
          this.ID=id
          this.getProduct(id)
        }
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.pro{
  width:100%;
  .banner{
    width:100%;
    position: relative;
    .text{
      position: absolute;
      top:60%;
      left: 11%;
      color:white;
      span{
        font-size: 35px;
        font-weight: bold;
        display: inline-block;
        padding-bottom: 10px;
        position: relative;
        border-bottom: 1px solid rgba(255,255,255,.3);
      }
    }
    .threeBtn{
      width:100%;
      color:white;
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      ul{
        width:1280px;
        padding-inline-start: 0px;
        list-style: none;
       margin: 0 auto;
        display: flex;
        li{
          float: left;
          width:20%;
          margin-left: 0.1%;
          padding:15px 10px;
          background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
          background-color:rgba(255,255,255,0.9);
          background-size: 100% 0%;
          text-transform: uppercase;
          -webkit-transition: all .5s;
          transition: all .5s;
          color:#0C3665;
          position: relative;
          span{
            display: inline-block;
            width:100%;
            text-align: center;
            font-weight: bold;
            cursor: pointer;
          }
          .proItem{
            position: absolute;
             bottom: 100%;
            width:100%;
            left: 0;
             background-color: rgba(233, 233, 234, 0.4);
            padding:15px 0;
            display:  none;
            border-top-left-radius: 5%;
            border-top-right-radius: 5%;
           p{
             text-align: center;
             color:#0C3665;
             cursor: pointer;
           }
          }
        }
        li:hover{
          background-size: 100% 100%;
          color:white;
        }
        li:hover .proItem{
          display: inline-block;
        }
      }

    }
  }
  .title{
    width:100%;
    text-align: center;
    padding-bottom: 60px;
    padding-top: 60px;
    p{
      font-size: 25px;
      font-weight: bold;
      color:#0C3665;
      margin-block-start: 0em;
    }
    .three{
      width:20%;
      height:1px;
      margin: 0 auto;
      position: relative;
      span{
        width:40%;
        display: inline-block;
        height:100%;
        background-color: #ECECEC;
        position: absolute;
      }
      img{
        position: absolute;
        left: 45%;
        top:-10px;
      }
    }
  }
  .main{
    width:1280px;
    margin: 0 auto;
    padding-bottom: 60px;
    border-bottom: 1px solid #E0E0E0;
    .fourImg{
      width:95%;
      display: flex;
      flex-direction: row;
      margin-left: 2.5%;
      padding-left: 5%;
      flex-wrap: wrap;
      .item{
        width:20%;
        height:310px;
        margin-left: 2%;
        position: relative;
        cursor: pointer;
        margin-top: 20px;
        border: 1px solid #f5f5f5;
        img{
          position: absolute;
          width:80%;
          height:200px;
          margin-left: 10%;
          margin-top: 10%;
          cursor: pointer;
          transition: all 1s;
          z-index: 999;
        }
        img:hover{
          transform: scale(1.1);
        }
        .twoText{
          position: absolute;
          bottom: 5%;
          display: flex;
          flex-direction: column;
          text-align: center;
          width:100%;
          span{
            margin-top: 10px;
          }
          span:first-child{
            color:#0C3665;
            font-weight: bold;
            font-size: 20px;
          }
          span:last-child{
            color:#9F9F9F;
            font-size: 14px;
            font-family: light;
          }
        }
        .fourLine{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          .anim-border{
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            position: relative;
            .loc_l{
              bottom: 0;
              left: 0;
              width: 1px;
              height: 0;
            }
            .loc_r{
              top: 0;
              right: 0;
              width: 1px;
              height: 0;
            }
            .loc_t{
              top: 0;
              left: 0;
              width: 0;
              height: 1px;
            }
            .loc_b{
              bottom: 0;
              right: 0;
              width: 0;
              height: 1px;
            }
            .oneLine{
              background-color: #cf3120;
              position: absolute;
              -webkit-transition: width .8s,height .8s,top .8s;
              transition: width .8s,height .8s,top .8s;
            }
          }
        }
      }
      .item:hover .fourLine .anim-border .loc_l{
        height:100%;
      }
      .item:hover .fourLine .anim-border .loc_r{
        height:100%;
      }
      .item:hover .fourLine .anim-border .loc_t{
        width:100%;
      }
      .item:hover .fourLine .anim-border .loc_b{
        width:100%;
      }
    }
    .an{
      width:100%;
      text-align: center;
      margin-top: 30px;
      .btn{
        font-weight: bold;
        display: inline-block;
        color:#C7000C;
        padding: 8px 3%;
        font-size: 12px;
        border: 1px solid #0C3665;
        -webkit-border-radius: 60px / 60px;
        -moz-border-radius: 60px / 60px;
        border-radius: 60px / 60px;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
      }
      .btn:hover{
        background-size: 100% 100%;
        color: white;
      }
    }
  }
  @media screen and (max-width:768px){
    .banner{
      img{
        height:500px !important;
        object-fit: cover;
      }
    }
    .main{
      width:100%;
      .fourImg{
        .item{
          height:200px;
        }
      }
    }
  }
  @media screen and (max-width:450px){
    .banner{
      .threeBtn{
      position: static;
        ul{
          flex-direction: column;
          li{
            width:100%;
            span{
              font-size: 14px;
            }
          }
        }
      }
      .text{
        top:40%;
      }
    }
    .main{
      .fourImg{
        flex-wrap: wrap;
        padding-left: 1.5%;
        .item{
          height:180px;
          width:45%;
          .twoText{
            span:first-child{
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue